import { render, staticRenderFns } from "./NewOrderCaseType.vue?vue&type=template&id=bb990530"
import script from "./NewOrderCaseType.vue?vue&type=script&lang=js"
export * from "./NewOrderCaseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports